import React from 'react'
import {Switch, Route} from 'react-router-dom'

import UserForm from 'components/User/UserForm'
import UserLogIn from 'modulesPublic/UserLogIn'

const RoutesPublic = () => (
  <Switch>
    <Route exact path='/' component={UserLogIn}/>
    <Route path='/register/:token?' render={({match, history}) => <UserForm initialValue={{token: match?.params.token}} history={history}/>}/>
  </Switch>
)

export default RoutesPublic
